import React, { FC } from "react";
import { Position } from "@xyflow/react";

import { StyledCard, StyledHandle } from "./CompanyNode.styled";

import { Box, Typography, CardContent } from "@components/base";

export interface CompanyNode {
  id: string;
  data: {
    name: string;
  };
}

const CompanyNode: FC<CompanyNode> = (props) => {
  const { data, id } = props;
  const { name } = data;

  return (
    <StyledCard>
      <StyledHandle
        id={id}
        type="target"
        position={Position.Top}
        isConnectable={false}
      />
      <CardContent>
        <Box alignItems="center" display="flex" flexDirection="column">
          <Typography variant="h6">{name}</Typography>
        </Box>
      </CardContent>
      <StyledHandle
        id={id}
        type="source"
        position={Position.Bottom}
        isConnectable={false}
      />
    </StyledCard>
  );
};

export default CompanyNode;
